import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import CartValueComp from '../../components/CartValueComp/CartValueComp';
import ProductDescription from './Description';

export default function ProductDetails ({ product,handleColorClick,availableColors,handleSizeClick,availableSizes,

    selectedColor,
    selectedSizes,
    selectedVariant,
    myVariant


 }) {

  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);


   const selected = myVariant.find(
        (variant) =>
          variant.color === selectedColor &&
          variant.size === selectedSizes
      );



  console.log("console log product changed to new slectd product", product);

  return (
    <div className="w-full lg:w-1/3 lg:sticky lg:top-8 lg:self-start">
      <div className="lg:pl-4 xl:pl-6">
        {/* Product Title */}
        <div className="mb-1 flex flex-col justify-start items-start">
          <h1 className="text-lg sm:text-xl font-normal w-full text-left tracking-wide mb-3 text-[#111]">{product?.name}</h1>
          {/* <p className="text-xs text-gray-500 uppercase tracking-widest mb-1">{product?.brand}</p> */}
         <div className='flex justify-start items-center'> <p className=" font-normal font-poppins text-sm ">₹ {product?.current_price}</p> 
         
         <p className=" font-normal text-sm line-through ml-2">₹ {product?.base_price}</p>

        
         
         
         </div>

          <p className='text-[13px] text-[#999] mt-2'> Only {selected?.stock_quantity?selected?.stock_quantity:'limited'} stock left</p>
        </div>

        {/* Color Selection */}
        <div className="mb-3">
         {/*  <div className="flex items-center justify-between mb-3">
            <span className="text-xs uppercase tracking-wide">COLOR — {product?.selectedColor}</span>
          </div> */}
          <div className="flex gap-2">
            {availableColors.map((color, index) => (
              <button
                key={index}
                onClick={() => handleColorClick(color)}
                className={`w-7 h-7 sm:w-8 sm:h-8 rounded border-2 transition-colors ${
                  selectedColor === index ? 'border-black' : 'border-gray-200 hover:border-gray-400'
                }`}
                style={{ backgroundColor: color }}
              />
            ))}
          </div>
        </div>

        {/* Stock Status */}
       {/*  <p className="text-xs text-start w-full text-gray-500 italic mb-2">Only 1 in stock!</p> */}

        {/* Size Selection */}
        <div className="mb-6">
          <span className="text-start w-full text-xs uppercase mr-auto tracking-wide mb-3 flex justify-start">SIZE</span>
          <div className="flex justify-start items-center gap-2">
            <div className="size-options flex justify-start items-center w-full">
             
              {["XS", "S", "M", "L", "XL", "XXL"].map((size) => (
                <button
                  key={size}
                  className="size-button w-[31px] text-sm sm:w-[40px] h-[31px] sm:h-[40px] flex items-center justify-center border border-gray-300 rounded transition-colors"
                  style={{
                    backgroundColor:
                      selectedSizes === size ? "#ddd" : "transparent",
                    textDecoration: availableSizes.includes(size)
                      ? "none"
                      : "line-through",
                    color: availableSizes.includes(size) ? "#444" : "#999",
                    cursor: availableSizes.includes(size)
                      ? "pointer"
                      : "not-allowed",
                  }}
                  onClick={() =>
                    availableSizes.includes(size) && handleSizeClick(size)
                  }
                  disabled={!availableSizes.includes(size)}
                >
                  {size}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Add to Cart */}
       {/*  <button className="w-full bg-gray-900 text-white py-3 text-xs sm:text-sm uppercase tracking-widest hover:bg-black transition-colors mb-6">
          ADD TO CART
        </button> */}

        {selected.stock_quantity>0? <CartValueComp
                          selVariant={selectedVariant}
                          variant={myVariant}
                          
                 />:<>
                 <div className='w-[121px] h-5 bg-[#333] text-[#fff]'>
                  Our of stock
                 </div>
                 </>}
       

        {/* Description */}
        <ProductDescription product={product} />
      </div>
    </div>
  );
};